/** Joins class names, skipping the empty ones. For src/ui only: screens never write classes. */
export function cx(...names: (string | false | null | undefined)[]): string {
  return names.filter(Boolean).join(' ')
}
